import { US_LOCALE } from "@/i18n/config";

export const US_MARKET_GUESS_API_PATH = "/api/us-market-guess";

/** Closing the banner is remembered in this browser; it doesn't come back. */
export const US_MARKET_BANNER_DISMISSED_KEY =
  "whoppah:us-market-banner-dismissed";
/** The guess is asked once per browser session, not on every page. */
export const US_MARKET_GUESS_SESSION_KEY = "whoppah:us-market-guess";

/**
 * Where the banner leads. An English page has the same path on `/en-us`, so the visitor lands on
 * the same product or list; the other languages' paths are translated, so they go to the US home.
 * Query and hash are dropped: a `?currency=` belongs to the page it was on (WHO-6199).
 */
export const usMarketHref = (
  locale: string | undefined,
  asPath: string
): string => {
  const path = asPath.split(/[?#]/)[0] ?? "/";

  return locale === "en" && path !== "/"
    ? `/${US_LOCALE}${path}`
    : `/${US_LOCALE}`;
};

const read = (storage: () => Storage, key: string): string | null => {
  try {
    return storage().getItem(key);
  } catch {
    return null;
  }
};

const write = (storage: () => Storage, key: string, value: string) => {
  try {
    storage().setItem(key, value);
  } catch {
    /* Storage blocked (private mode, site data off): the banner just asks again next time. */
  }
};

export const isUsMarketBannerDismissed = () =>
  read(() => window.localStorage, US_MARKET_BANNER_DISMISSED_KEY) === "1";

export const dismissUsMarketBanner = () =>
  write(() => window.localStorage, US_MARKET_BANNER_DISMISSED_KEY, "1");

/** `true` / `false` once asked this session, `null` before. */
export const readSessionGuess = (): boolean | null => {
  const value = read(() => window.sessionStorage, US_MARKET_GUESS_SESSION_KEY);

  return value === null ? null : value === "1";
};

export const rememberSessionGuess = (fromUs: boolean) =>
  write(
    () => window.sessionStorage,
    US_MARKET_GUESS_SESSION_KEY,
    fromUs ? "1" : "0"
  );
